import React,{ useEffect, useState } from "react";
import { useBookContext } from "../../../context/book/book-context";
import { Chapter } from "../chapter/chapter";
import * as S from "./chapter-list.style";
import { BiChevronUp } from "react-icons/bi";

export const ChapterList = () => {
  const { book } = useBookContext();
  const [hiddenChapters, setHiddenChapters] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setHiddenChapters(false);
    }, 500);
  }, []);

  const mode = "normal";

  return (
    <S.Wrapper expanded={!hiddenChapters}>
      <S.ContainerCard>
        <S.ContainerCardToolbar
          onClick={() => setHiddenChapters(!hiddenChapters)}
        >
          <S.ChaptersLabel>
            <span>{book && book.chapters && book.chapters.length}</span>
            <p> Capítulos</p>
          </S.ChaptersLabel>

          {mode !== "normal" && (
            <S.ChaptersLabel className="bi-chevron-icon">
              <BiChevronUp size={20} />
            </S.ChaptersLabel>
          )}
        </S.ContainerCardToolbar>
        <S.List>
          {book && book.chapters && book.chapters.map((chapter) => (
            <li key={chapter.title}>
              <Chapter chapter={chapter} />
            </li>
          ))}
        </S.List>
      </S.ContainerCard>
    </S.Wrapper>
  );
};
